export default "__VITE_ASSET__C6C2wPQ$__"